import React from 'react';

import { Button } from '@chakra-ui/react';

const Share = ({title, text, url, onError}) => {

  // console.log('condivido', url)

  if (!navigator.canShare) {
    return null
  }

  return (
    <Button
      my={4}
      onClick={async () => {
        try {
          await navigator.share({title, text, url});
        } catch (err) {
          onError(err)
        }
      }}
    >
      Condividi
    </Button>
  );
};

export default Share;
